import { render, staticRenderFns } from "./PhoneLookup.vue?vue&type=template&id=cf9b153c&scoped=true"
import script from "./PhoneLookup.vue?vue&type=script&lang=js"
export * from "./PhoneLookup.vue?vue&type=script&lang=js"
import style0 from "./PhoneLookup.vue?vue&type=style&index=0&id=cf9b153c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9b153c",
  null
  
)

export default component.exports